import SimpleList from './simple-list/simple-list'

export default {
  SimpleList,
}